import { PaginationAPI } from '@/types/pagination';
import { Pagination } from '@/constants/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BankState = {
  data: BankType[];
  pagination: PaginationAPI;
  loading: boolean;
};

export const bankInitialState: BankState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
};

const slice = createSlice({
  name: 'bank',
  initialState: bankInitialState,
  reducers: {
    setListBankAction(
      state,
      action: PayloadAction<{
        data: BankType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
        append?: boolean;
      }>,
    ) {
      const { payload } = action;

      if (payload.append) {
        // Append new data to existing data
        state.data = [...state.data, ...payload.data];
      } else {
        // Replace existing data
        state.data = payload.data;
      }

      state.pagination = payload.pagination || state.pagination;
    },
    setBankLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateBankAction(state, { payload }: PayloadAction<BankType>) {
      state.data = state.data.map((item) => {
        if (item.id === payload.id) {
          return payload;
        }
        return item;
      });
    },
  },
});

export const { setListBankAction, setBankLoading, updateBankAction } = slice.actions;
export default slice.reducer;
